export default "__VITE_ASSET__02aed494__"